import initialState from "./InitialStates";
import Actions from "../actions/Actions";
import update from "immutability-helper";
import {message} from "antd";
import jwt_decode from "jwt-decode";
import Ability from "../../config/Ability";
import userPermissions from "../../config/userPermissions";
import _ from "lodash";

message.config({
    top: 70,
    maxCount: 2,
});

const authReducer = (state = initialState.user, action) => {
    let userSession = "";
    let userInfo = "";
    let payload = "";
    let arrRole = "";
    let adminroles = false;
    let merchatRole = false;
    let ceylincoRole = false;
    let financeRole = false;
    let redmoAdminRole = false;
    switch (action.type) {
    case Actions.USER_SET:
        return update(state, {info: {$set: action.userInfo}, isAuthenticated: {$set: action.isAuthenticated}});

    case Actions.USER_LOGIN_REQUEST:
        return update(state,
            {
                loading: {$set: true},
                info: {
                    id: {$set: ""},
                    fname: {$set: ""},
                    lname: {$set: ""},
                    email: {$set: ""},
                    mobile: {$set: ""},
                    nic: {$set: ""},
                    picture: {$set: ""},
                    userRoles: {$set: []},
                }
            });

    case Actions.USER_LOGIN_SUCCESS:
        localStorage.setItem("id_token", action.id_token);
        localStorage.setItem("acc_token", action.acc_token);

        userInfo = state.info;
        payload = jwt_decode(action.id_token);
        localStorage.setItem("_email", payload.email);
        localStorage.setItem("_name", payload.given_name);
        userInfo.id = payload.sub;
        userInfo.fname = payload.given_name;
        userInfo.lname = payload.family_name;
        userInfo.email = payload.email;
        userInfo.mobile = payload.phone_number;
        userInfo.nic = payload["custom:nic"];
        userInfo.picture = payload["custom:picture"] !== undefined ? payload["custom:picture"] : "";
        if (payload.hasOwnProperty("cognito:groups")) {
            arrRole = payload["cognito:groups"];
            adminroles =  _.includes(arrRole, "admin");
            merchatRole = _.includes(arrRole, "merchant");
            ceylincoRole = _.includes(arrRole, "ceylinco");
            financeRole = _.includes(arrRole, "finance");
            redmoAdminRole = _.includes(arrRole, "redmo_admin");

            if (adminroles) {
                Ability.update(userPermissions.adminPermission);
            } 
            else if(ceylincoRole){
                Ability.update(userPermissions.ceylincoPermission);
            }
            else if(financeRole){
                Ability.update(userPermissions.financePermission);
            }
            else if(merchatRole){
                Ability.update(userPermissions.merchantPermission);
            }
            else if(redmoAdminRole){
                Ability.update(userPermissions.redmoAdminPermission);
            }
            else {
                Ability.update(userPermissions.userPermission);
            }

            localStorage.setItem("_roles", JSON.stringify(arrRole));
            for (let i = 0; i < arrRole.length; i++) {
                userInfo.userRoles.push(arrRole[i]);
            }
        } else {
            localStorage.setItem("_roles", []);
            Ability.update(userPermissions.userPermission);
        }

        userSession = state.session;
        userSession.accessToken = action.acc_token;
        localStorage.removeItem("isRegister");

        message.success(action.message);
        return update(state, {
            loading: {$set: false}, isAuthenticated: {$set: true},
            message: {$set: action.message},
            isRegister: {$set: false}
        });

    case Actions.USER_LOGIN_WARNING:
        message.warning(action.message, 5);
        return update(state, {
            loading: {$set: false},
            isAuthenticated: {$set: false},
            message: {$set: action.message}
        });

    case Actions.USER_LOGIN_FAIL:
        message.error(action.message, 5);
        return update(state, {
            loading: {$set: false},
            isAuthenticated: {$set: false},
            message: {$set: action.message}
        });

    case Actions.USER_SESSION_EX:
        userInfo = state.info;
        payload = jwt_decode(action.id_token);

        localStorage.setItem("id_token", action.id_token);
        localStorage.setItem("acc_token", action.acc_token);
        localStorage.setItem("_email", payload.email);
        localStorage.setItem("_name", payload.given_name);
        userInfo.id = payload.sub;
        userInfo.fname = payload.given_name;
        userInfo.lname = payload.family_name;
        userInfo.email = payload.email;
        userInfo.mobile = payload.phone_number;
        userInfo.nic = payload["custom:nic"];
        userInfo.picture = payload["custom:picture"] !== undefined ? payload["custom:picture"] : "";
        if (payload.hasOwnProperty("cognito:groups")) {
            arrRole = payload["cognito:groups"];
            adminroles =  _.includes(arrRole, "admin");
            merchatRole = _.includes(arrRole, "merchant");
            ceylincoRole = _.includes(arrRole, "ceylinco");
            financeRole = _.includes(arrRole, "finance");
            redmoAdminRole = _.includes(arrRole, "redmo_admin");

            if (adminroles) {
                Ability.update(userPermissions.adminPermission);
            } 
            else if(ceylincoRole){
                Ability.update(userPermissions.ceylincoPermission);
            }
            else if(financeRole){
                Ability.update(userPermissions.financePermission);
            }
            else if(merchatRole){
                Ability.update(userPermissions.merchantPermission);
            }
            else if(redmoAdminRole){
                Ability.update(userPermissions.redmoAdminPermission);
            }
            else {
                Ability.update(userPermissions.userPermission);
            }

            localStorage.setItem("_roles", JSON.stringify(arrRole));
            for (let i = 0; i < arrRole.length; i++) {
                userInfo.userRoles.push(arrRole[i]);
            }
        } else {
            localStorage.setItem("_roles", []);
            Ability.update(userPermissions.userPermission);
        }

        userSession = state.session;
        userSession.accessToken = action.acc_token;
        localStorage.removeItem("isRegister");

        return update(state, {
            loading: {$set: false}, message: {$set: action.payload},
            isAuthenticated: {$set: true},
            isRegister: {$set: false}
        });

    case Actions.USER_SESSION_NUL:
        return update(state, {
            loading: {$set: false},
            message: {$set: action.payload},
            isAuthenticated: {$set: false}
        });

    case Actions.USER_LOGOUT:
        localStorage.removeItem("id_token");
        localStorage.removeItem("acc_token");
        localStorage.removeItem("_email");
        localStorage.removeItem("_name");
        localStorage.removeItem("isRegister");
        localStorage.removeItem("_roles");
        return update(state, {
            loading: {$set: false},
            isAuthenticated: {$set: false},
            info: {
                id: {$set: ""},
                fname: {$set: ""},
                lname: {$set: ""},
                email: {$set: ""},
                mobile: {$set: ""},
                nic: {$set: ""},
                userRoles: {$set: []},
            }
        });

    case Actions.USER_REGISTER_REQUEST:
        return update(state, {loading: {$set: true}});
    case Actions.USER_REGISTER_SUCCESS:
        localStorage.setItem("isRegister", true);
        message.success(action.message);
        return update(state, {loading: {$set: false}, isRegister: {$set: true}});
    case Actions.USER_REGISTER_FAIL:
        message.error(action.message, 5);
        return update(state, {loading: {$set: false}});

    case Actions.USER_PASSWORD_CHG_REQUEST:
        return update(state, {isPasswordChg: {$set:true}});
    case Actions.USER_PASSWORD_CHG_SUCCESS:
        message.success(action.message);
        return update(state, {isPasswordChg: {$set:false}});
    case Actions.USER_PASSWORD_CHG_FAIL:
        message.error(action.message, 5);
        return update(state, {isPasswordChg: {$set:false}});

    case Actions.USER_CHG_ATTR_REQUEST:
        return update(state, {isInfoChg: {$set: true}});
    case Actions.USER_CHG_ATTR_SUCCESS:
        message.success("User Update Success.", 3);
        return update(state, {
            isInfoChg: {$set: false},
            info: {
                fname: {$set: action.payload.given_name},
                lname: {$set: action.payload.family_name},
                email: {$set: action.payload.email},
                mobile: {$set: action.payload.phone_number},
                nic: {$set: action.payload["custom:nic"]},
            }
        });
    case Actions.USER_CHG_ATTR_FAIL:
        message.error("User Info Change Fail.", 5);
        return update(state, {isInfoChg: {$set: false}});

    case Actions.USER_NEW_ATTR:
        return update(state, {
            info: {
                fname: {$set: action.payload.given_name},
                lname: {$set: action.payload.family_name},
                email: {$set: action.payload.email},
                mobile: {$set: action.payload.phone_number},
                nic: {$set: action.payload["custom:nic"]}
            }
        });

    case Actions.USER_PRO_IMG_REQUEST:
        return update(state, {
            isProPicUpload: {$set: true}
        });

    case Actions.USER_PRO_IMG_SUCCESS:
        return update(state, {
            isProPicUpload: {$set: false},
            info: {
                //picture: {$set: (action.payload.length > 0) ? action.payload[0] : ''}
                picture: {$set: action.payload }
            }
        });

    case Actions.USER_PRO_IMG_FAIL:
        return update(state, {
            isProPicUpload: {$set: false}
        });


    default:
        return state;
    }
};

export default authReducer;